<p-table [value]="[mark]" [style]="{ 'font-size': '12px', 'margin-bottom': '10px' }">
  <ng-template pTemplate="colgroup">
    <colgroup>
      <col *ngIf="mark.type == 'mark'" style="width: 85px" />
    </colgroup>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>{{ appSettings.translate[appSettings.selectedLang]['marshal_num'] }}</th>
      <th>{{ appSettings.translate[appSettings.selectedLang]['date'] }}</th>
      <th>{{ appSettings.translate[appSettings.selectedLang]['time'] }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-mark>
    <tr>
      <td>
        <input
          pInputText
          [disabled]="mark.type === 'finish' || mark.type === 'finish/mark'"
          type="text"
          [(ngModel)]="mark.marshal"
          [pKeyFilter]="'int'"
          class="marshal-input"
        />
      </td>
      <td>
        <p-calendar
          appendTo="body"
          [(ngModel)]="mark.markDate"
          dateFormat="dd.mm.yy"
          dateMask
          [inputStyle]="{ width: '100%' }"
        ></p-calendar>
      </td>
      <td>
        <p-inputMask [(ngModel)]="markTime" mask="99:99:99" slotChar="hh:mm:ss" [style]="{ width: '100%' }"></p-inputMask>
        <!-- <p-calendar
          appendTo="body"
          [(ngModel)]="markTime"
          [timeOnly]="true"
          [showSeconds]="true"
          dateMask
          [inputStyle]="{ width: '100%' }"
        ></p-calendar> -->
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="button-wrapper">
  <p-button
    [label]="appSettings.translate[appSettings.selectedLang]['change']"
    [style]="{ 'background-color': '#254C74' }"
    (onClick)="save()"
    [disabled]="mark.type == 'mark' && mark.marshal === undefined"
  ></p-button>
</div>
